<template>
    <div class="hourHeatMapContainer">
        <div class="hourHeadMapBox">
            <div class="title pl-2 pt-2 d-flex justify-content-center">시간대 사용 패턴 분석</div>
            <div ref="heatmap" class="hourHeatMap"></div>
        </div>

        <div class="weekAvg">
            <div class="title pl-2 pt-2 d-flex justify-content-center">
                주별 총 사용량
            </div>
            <bar-chart-next-heat-map
                distinc="sum"
                :detailInfo="detailInfo"
                :resultData="resultData"
                :hideInfoPanel="hideInfoPanel"
            ></bar-chart-next-heat-map>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import BarChartNextHeatMap from "./BarChartNextHeatMap.vue";
export default {
    props: ["resultData", "detailInfo", "hideInfoPanel"],
    components: { BarChartNextHeatMap },
    data() {
        return {
            chart: null,
        };
    },
    watch: {
        resultData: {
            deep: true,
            handler(newVal) {
                if (newVal.hourlyPattern.value.length !== 0) {
                    this.initHeatMap();
                }
            },
        },
        hideInfoPanel() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    },
    mounted() {
        this.initHeatMap();
        window.addEventListener("resize", this.resizeChart);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeChart);
        if (this.chart) {
            this.chart.dispose();
        }
    },
    methods: {
        unitCalc(head) {
            return head.dispUnit ?? head.unitSmallCode;
        },
        getMinMax(data) {
            let min = Number.POSITIVE_INFINITY;
            let max = Number.NEGATIVE_INFINITY;

            data.forEach((item) => {
                const value = item[2]; // Heatmap value
                if (value < min) min = value;
                if (value > max) max = value;
            });

            return { min, max };
        },
        initHeatMap() {
            this.chart = echarts.init(this.$refs.heatmap);

            const ySeries = this.resultData.hourlyPattern.ySeries || [];
            const xSeries = this.resultData.hourlyPattern.xSeris || [];
            const unit = this.unitCalc(this.resultData.headers.find((item) => item.roleType === "Main"));
            const { min, max } = this.getMinMax(this.resultData.hourlyPattern.value);

            const option = {
                tooltip: {
                    position: "top",
                    formatter: function(params) {
                        return `<div style="font-size: 12px;display: flex; justify-content: space-between;">
                                    <div>
                                    ${params.marker}
                                    <span> ${ySeries[params.value[1]]}</span>
                                  <span> ${xSeries[params.value[0]]}</span></span> &nbsp; &nbsp;
                                    </div>
                                    <span style="font-weight: bold;">${params.value[2]}&nbsp;${unit}</span>
                                </div> `;
                    },
                },
                visualMap: {
                    min: min, // Dynamic min value
                    max: max, // Dynamic max value
                    calculable: true,
                    orient: "horizontal",
                    left: "center",
                    bottom: "5%",
                    formatter: (params) => {
                        console.log(typeof params);
                        return `${params.toFixed(2)}`;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xSeries,
                    splitArea: {
                        show: true,
                    },
                },
                yAxis: {
                    type: "category",
                    data: ySeries,
                    splitArea: {
                        show: true,
                    },
                    axisLabel: {
                        inside: false,
                        formatter: (hour) => `${hour}`,
                    },
                },
                grid: {
                    // left: "6%",
                    right: "3%",
                    width: "90%",
                    height: "70%",
                    bottom: "30%",
                },
                series: [
                    {
                        name: "Usage Pattern",
                        type: "heatmap",
                        data: this.resultData.hourlyPattern.value,
                        label: {
                            show: true,
                            formatter: (params) => params.value[2].toFixed(1),
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: "rgba(0, 0, 0, 0.5)",
                            },
                        },
                    },
                ],
            };

            this.chart.setOption(option);
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    },
};
</script>

<style scoped>
.hourHeatMapContainer {
    width: 100%;
    height: 100%;
    display: flex;
}
.hourHeadMapBox {
    display: flex; /* 명시적으로 flexbox 설정 */
    flex-direction: column;
    width: 70%;
    height: 100%;
    box-shadow: 4px 0px 12px 0px rgba(0, 0, 0, 0.1); /* 확산 반경(0px) 추가 */
}
.hourHeatMap {
    width: 100%;
    height: 100%;
    padding-top: 20px;
}
.weekAvg {
    width: 30%;
    height: 100%;
}
.title {
    font-weight: bold;
}
</style>
